import { type Wlsy } from 'types/wlsy'
import { logger } from './logger'

export const wlsly = () => {
  try {
    return window.wellesley?.v1 || (window.wellesley as unknown as Wlsy)
  } catch (e) {
    logger.error('Error getting window.wellesley:', e)
  }
}
